/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/

import { Feature, LineString } from 'geojson';
import { VisionMap } from './map';

import { VisionApplication } from '../application';
import { PublishTopic } from '../events';
import { IPubSubSubscriber } from '../pubsub';

export class TrackLine implements IPubSubSubscriber {
    map!: VisionMap | null;
    polyline!: google.maps.Polyline;
    bounds!: google.maps.LatLngBounds;
    identifier = 'ce43bdf8-4c38-49a9-bb4b-8b67d48808e0';

    markers!: google.maps.Marker[];
    markerState = false;

    offset_start = [0, 25, 75];
    offsets = [0, 25, 75];
    offset = 0;
    frame = 0;

    animationInterval: number;

    lineSymbol = {
        path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
        scale: 4,
        strokeWeight: 2,
        strokeColor: '#1D4F91',
    };

    constructor() {
        /*
        var polyOptions = { 
            strokeColor: "#FF00FF", 
            strokeWeight: 2, 
            geodesic: true,
            icons: [{icon: this.lineSymbol, offset: "0", repeat: "100px"}]
        };
        */
        const polyOptions = {
            strokeOpacity: 1,
            strokeColor: '#FF00FF',
            strokeWeight: 4,
            geodesic: true,
            icons: [
                {
                    icon: {
                        path: 'M 0,-1 0,1',
                        strokeOpacity: 0.75,
                        scale: 6,
                        strokeColor: '#1D4F91',
                    },
                    offset: '0',
                    repeat: '200px',
                },
            ],
        };

        this.polyline = new google.maps.Polyline(polyOptions);
        this.markers = new Array<google.maps.Marker>();
        this.bounds = new google.maps.LatLngBounds();

        VisionApplication.getInstance().pubsub.subscribe(PublishTopic.MAP_ZOOM_CHANGE, this);

        this.animationInterval = window.setInterval(() => {
            this.animatePath();
        }, 30);
    }

    public remove(): void {
        VisionApplication.getInstance().pubsub.unsubscribe(PublishTopic.MAP_ZOOM_CHANGE, this);
        this.polyline.setMap(null);
        this.markers.forEach((marker) => {
            marker.setMap(null);
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notify(msg: string, data?: any): void {
        switch (msg) {
            case PublishTopic.MAP_ZOOM_CHANGE: {
                const zoom = data as number;
                this.markers.forEach((marker) => {
                    if (zoom > 16) {
                        if (this.markerState == true) {
                            if (this.map) {
                                marker.setMap(this.map.map);
                            }
                        }
                    } else {
                        marker.setMap(null);
                    }
                });
                break;
            }
        }
    }

    public setColour(colour: string): void {
        this.polyline.setOptions({ strokeColor: colour });
    }

    animatePath() {
        this.frame = this.frame + 1;
        const icons = this.polyline.get('icons');
        icons[0].offset = this.frame + 'px';
        //console.log(icons[0].offset);
        this.polyline.set('icons', icons);
        /*
        if ( this.frame > 200  ) {
            //this.frame = 0;
        }
        */
    }

    addPoint(lat: number, lon: number, color: string, rotation: number) {
        //this.polyline.getPath().insertAt(0, new google.maps.LatLng(lat, lon));

        this.polyline.getPath().push(new google.maps.LatLng(lat, lon));

        this.bounds.extend(new google.maps.LatLng(lat, lon));

        const marker = new google.maps.Marker({
            icon: {
                path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                rotation: rotation,
                scale: 2,
                strokeWeight: 2,
                strokeColor: color,
            },
            position: new google.maps.LatLng(lat, lon),
            optimized: true,
        });
        this.markers.push(marker);
        return marker;
    }

    /** Set the map for the data
     *
     */
    public setMap(map: VisionMap) {
        this.map = map;

        if (map) {
            //console.log('Setting Map on Polyline');
            this.polyline.setMap(map.map);
            //this.markers.forEach ( (marker)=>{
            //    marker.setMap(map.map);
            //});
        }
    }

    /** Set the visible state of a map
     *
     * @param state True to show and false to hide.
     */
    public setVisisble(state: boolean) {
        if (state == true) {
            if (this.map) {
                this.polyline.setMap(this.map.map);
            }
        } else {
            this.polyline.setMap(null);
        }
    }

    public showMarkers(state: boolean, zoom = 100) {
        this.markerState = state;
        if (state == true) {
            this.markers.forEach((marker) => {
                if (this.map) {
                    if (zoom > 16) marker.setMap(this.map.map);
                }
            });
        } else {
            this.markers.forEach((marker) => {
                marker.setMap(null);
            });
        }
    }
}

export class VisionMapPolyline {
    map: VisionMap | null;
    path!: Feature<LineString>;
    dataLayer!: google.maps.Data;

    polyline!: google.maps.Polyline;
    markers!: google.maps.Marker[];

    constructor(map: VisionMap | null, geometry: LineString) {
        this.map = map;

        const lineString: Feature<LineString> = {
            type: 'Feature',
            properties: {},
            geometry: geometry,
        };
        this.path = lineString;
    }

    show() {
        if (this.map == null) {
            return;
        }
        this.dataLayer = new google.maps.Data();
        this.dataLayer.addGeoJson(this.path);
        this.dataLayer.setMap(this.map.map);
        this.dataLayer.setStyle(function (_feature) {
            return {
                strokeWeight: 1,
                strokeColor: 'red',
            };
        });
    }
}
